'use client';

import React, { FC } from 'react';

import DatePicker, { DatePickerProps, registerLocale } from 'react-datepicker';

import { enUS, enGB, enAU, es, de, fr, nl } from 'date-fns/locale';

import './CalendarDatePicker.scss';

interface CalendarDatePickerProps extends Omit<DatePickerProps, 'onChange'> {
  onChange: (date: Date) => void;
  rangeStart?: Date;
  rangeEnd?: Date;
}

registerLocale('en-US', enUS);
registerLocale('en-GB', enGB);
registerLocale('en-AU', enAU);
registerLocale('en-EU', enGB);
registerLocale('es', es);
registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('nl', nl);

const CalendarDatePicker: FC<CalendarDatePickerProps> = ({
  onChange,
  selected,
  rangeStart,
  rangeEnd,
  highlightDates,
  locale,
}) => (
  <DatePicker
    inline
    previousMonthButtonLabel=""
    nextMonthButtonLabel=""
    calendarStartDay={1}
    onChange={(date) => date && onChange(date)}
    selected={selected}
    minDate={rangeStart}
    startDate={rangeStart}
    maxDate={rangeEnd}
    endDate={rangeEnd}
    highlightDates={highlightDates}
    locale={locale}
  />
);

export default CalendarDatePicker;
